import { runInAction } from "../../dependencies";
import { EventTags } from "../../data";
const mapStatisticsIconHelper = (shouldShowStatistics, event) => {
    event.statisticsIcon = {
        active: (shouldShowStatistics
            && event.tags.indexOf(EventTags.Stats) > -1),
        tooltip: "Statistics"
    };
    return event;
};
export const mapStatisticsIcon = (shouldShowStatistics, event) => runInAction(() => mapStatisticsIconHelper(shouldShowStatistics, event));
//# sourceMappingURL=mapStatisticsIcon.js.map